import axiosInstance from "@/plugins/axios";

const apiService = {
  get(resource, params, config) {
    return axiosInstance.get(resource, { params, ...config });
  },

  post(resource, data, config) {
    return axiosInstance.post(resource, data, config);
  },

  put(resource, data, config) {
    return axiosInstance.put(resource, data, config);
  },

  patch(resource, data, config) {
    return axiosInstance.patch(resource, data, config);
  },

  delete(resource, config) {
    return axiosInstance.delete(resource, config);
  },

  // You can add other custom methods here if needed
  // For example, for file uploads:
  // postWithFile(resource, data) {
  //   const_config = {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   };
  //   return axiosInstance.post(resource, data, _config);
  // },
};

export default apiService;